import React, { useState } from 'react';
import { DatePicker } from 'components/LegacyPickers';
import jMoment from 'moment-jalaali';
import { DatePickerPod, SimpleDialog , Icons} from 'components';
import { Button, Grid, Typography } from '@mui/material';
import persianJs from 'persianjs';
import { useStyles } from './FilterDateRangeStyle';

const FilterDateRange = ({
  onFilterChanged,
  columnDef,
  defaultStartDate = null,
  defaultEndDate = null,
  ...rest
}) => {
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);
  const [dateFilter, setDateFilter] = useState({
    startDate: '',
    endDate: '',
  });
  const [openDialog, setOpenDialog] = useState(false);

  const classes = useStyles();

  const handleChangeStart = (e) => {
    setStartDate(e);

    setDateFilter((prev) => ({
      ...prev,
      startDate: jMoment(e).format('jYYYY/jMM/jDD'),
    }));
  };

  const handleChangeEnd = (e) => {
    setEndDate(e);

    setDateFilter((prev) => ({
      ...prev,
      endDate: jMoment(e).format('jYYYY/jMM/jDD'),
    }));
  };

  const handleResetFilter = () => {
    handleChangeStart(null);
    handleChangeEnd(null);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    submitDialog(true);
  };

  const submitDialog = (resetFilter) => {
    setOpenDialog(false);
    const reset = resetFilter === true && (!defaultStartDate || !defaultEndDate);
    if (reset) {
      handleResetFilter();
    }
    const enDateFilter = { ...dateFilter };

    enDateFilter.startDate = enDateFilter.startDate
      ? persianJs(enDateFilter.startDate).toEnglishNumber().toString()
      : null;

    enDateFilter.endDate = enDateFilter.endDate
      ? persianJs(enDateFilter.endDate).toEnglishNumber().toString()
      : null;

    onFilterChanged(columnDef.tableData.id, reset ? null : enDateFilter);
  };

  const openDialogRange = () => {
    const newDate = new Date();
    const date = jMoment(newDate).format('jYYYY/jMM/jDD');
    const dateObj = {};

    if (!dateFilter.startDate) {
      dateObj.startDate = date;
    } else {
      dateObj.startDate = dateFilter.startDate;
    }

    if (!dateFilter.endDate) {
      dateObj.endDate = date;
    } else {
      dateObj.endDate = dateFilter.endDate;
    }

    setDateFilter(dateObj);

    setOpenDialog(true);
  };

  const ActionsBtn = () => {
    return (
      <>
        <Button variant="contained" color="primary" onClick={submitDialog}>
          اعمال
        </Button>

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>

        {!defaultStartDate || !defaultStartDate ? (
          <Button
            startIcon={<Icons icon="Trash" color="#2b3990" size="20" />}
            variant="contained"
            style={{ marginInlineStart: 'auto', marginInlineEnd: 8 }}
            onClick={() => {
              submitDialog(true);
            }}
          >
            حذف فیلتر
          </Button>
        ) : null}
      </>
    );
  };

  return (
    <>
      <Button
        fullWidth
        onClick={() => openDialogRange()}
        variant="outlined"
        className={classes.defaultLabelButton}
      >
        {startDate ? 'از ' : null}
        {startDate?.format('jYYYY/jMM/jDD')} {startDate && endDate ? 'تا ' : null}
        {endDate?.format('jYYYY/jMM/jDD')}
        {!startDate && !endDate ? 'انتخاب بازه' : null}
      </Button>

      <SimpleDialog
        fullWidth
        maxWidth="sm"
        open={openDialog}
        title="انتخاب بازه تاریخی"
        onClose={handleCloseDialog}
        actions={<ActionsBtn />}
      >
        <Grid container alignItems="center" justifyContent="center" spacing={3}>
          <Grid item xs={6}>
            <Typography color="textSecondary" gutterBottom>
              از تاریخ:
            </Typography>
            <DatePickerPod>
              <DatePicker
                {...rest}
                autoOk
                inputVariant="outlined"
                showTodayButton
                todayLabel="امروز"
                okLabel="تایید"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                value={startDate ?? null}
                onChange={handleChangeStart}
                disableFuture
              />
            </DatePickerPod>
          </Grid>
          <Grid item xs={6}>
            <Typography color="textSecondary" gutterBottom>
              تا تاریخ:
            </Typography>
            <DatePickerPod>
              <DatePicker
                {...rest}
                autoOk
                inputVariant="outlined"
                todayLabel="امروز"
                okLabel="تایید"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                value={endDate ?? null}
                {...(startDate
                  ? {
                    minDate: startDate,
                  }
                  : {})}
                onChange={handleChangeEnd}
                disableFuture
              />
            </DatePickerPod>
          </Grid>
        </Grid>
      </SimpleDialog>
    </>
  );
};



export default FilterDateRange;
